import { InvoicingSettingsEntryContext } from '../enums/invoicingSettingsEntryContext'
import { InvoicingSettingsSection } from '../enums/invoicingSettingsSection'

interface GetVisibleInvoicingSettingsSectionsOptions {
  canReadEDocuments: boolean
  entryContext?: InvoicingSettingsEntryContext
  isFrenchComplianceMode: boolean
}

type SectionAvailabilityRule = (options: GetVisibleInvoicingSettingsSectionsOptions) => boolean

const isAvailableForEntryContext =
  (requiredEntryContext: InvoicingSettingsEntryContext): SectionAvailabilityRule =>
  ({ entryContext }) =>
    !entryContext || entryContext === requiredEntryContext

// A section without a rule is always available.
const sectionToAvailabilityRule: Partial<Record<InvoicingSettingsSection, SectionAvailabilityRule>> = {
  [InvoicingSettingsSection.Compliance]: ({ isFrenchComplianceMode }) => isFrenchComplianceMode,
  [InvoicingSettingsSection.EInvoicing]: ({ canReadEDocuments }) => canReadEDocuments,
  [InvoicingSettingsSection.Invoice]: isAvailableForEntryContext(InvoicingSettingsEntryContext.Invoice),
  [InvoicingSettingsSection.Quote]: isAvailableForEntryContext(InvoicingSettingsEntryContext.Quote),
}

export const getVisibleInvoicingSettingsSections = (
  options: GetVisibleInvoicingSettingsSectionsOptions,
): InvoicingSettingsSection[] =>
  Object.values(InvoicingSettingsSection).filter((section) => sectionToAvailabilityRule[section]?.(options) ?? true)
